<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <!-- <production-list v-if="isMobile()">
        <v-app-bar-nav-icon
          v-if="SesionActiva"
          @click="drawer = !drawer"
        ></v-app-bar-nav-icon>
      </production-list> -->
      <v-app-bar-nav-icon
        v-if="SesionActiva"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="mr-2">Sistema de Tareas</v-toolbar-title>

      <!-- 
      <v-btn v-if="SesionActiva" @click="cerrarSesion" text>
        <span class="mr-2">Cerrar Sesion</span>
        <v-icon>mdi-account</v-icon>
      </v-btn> -->
    </v-app-bar>

    <v-navigation-drawer app v-model="drawer" temporary>
      <!-- -->
      <v-layout mt-4 column align-center>
        <v-flex>
          <!-- <v-avatar> -->
          <v-img src="../public/img/Logo-edese-hd.png" @click="Home()"></v-img>
          <!-- </v-avatar> -->
        </v-flex>
        <v-flex>
          <v-list-item-title class="text-h6"
            >{{ this.$store.getters.usuario.user_name }}
          </v-list-item-title>
        </v-flex>
        <v-flex>
          <v-list-item-subtitle>{{
            tipoUsuario(this.$store.getters.usuario.idRol)
          }}</v-list-item-subtitle>
        </v-flex>
      </v-layout>
      <br />
      <v-divider></v-divider>
      <v-list nav dense>
        <div v-for="(link, i) in links" :key="i">
          <!-- <div v-if="link.rol.includes($store.getters.usuario.rol)"> -->
          <v-list-item
            v-if="!link.subLinks"
            :to="link.to"
            avatar
            class="v-list-item"
          >
            <v-list-item-icon>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item>

          <v-list-group
            v-else
            no-action
            :prepend-icon="link.icon"
            :value="false"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ link.text }}</v-list-item-title>
            </template>

            <v-list-item
              v-for="sublink in link.subLinks"
              :to="sublink.to"
              :key="sublink.text"
            >
              <v-list-item-icon>
                <v-icon>{{ sublink.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ sublink.text }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <!-- </div> -->
        </div>
        <br />
        <v-divider></v-divider>
        <br />

        <v-list-item @click="cerrarSesion">
          <v-list-item-icon>
            <v-icon>mdi-power-standby</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Cerrar Sesión</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
//import sha512 from "js-sha512";
export default {
  name: "App",

  data: () => ({
    drawer: false,
    links: [],
  }),

  mounted() {
    // if (this.$store.getters.usuario.idRol)
    // {
    // }
  },

  computed: {
    SesionActiva() {
      console.log("Ingreso en sesion activa");
      this.setearMenu();

      if (
        this.$store.getters.usuario.expiration &&
        this.moment().isBefore(
          this.moment(this.$store.getters.usuario.expiration),
          "minute"
        )
      ) {
        return true;
      } else {
        this.cerrarSesion();
        return false;
      }

      //return true;
    },
  },
  methods: {
    async setearMenu() {
      console.log("El numero de rol del usuario es: ");
      console.log(this.$store.getters.usuario.idRol);
      console.log("El tipo es: ");
      console.log(typeof this.$store.getters.usuario.idRol);
      //console.log("El nombre de usuario es: ");
      //console.log(this.$store.getters.usuario.user_name)
      if (this.$store.getters.usuario.idRol == 1) {
        this.links = [
          {
            to: "/Usuarios",
            icon: "mdi-account-tie",
            text: "Usuarios",
            rol: ["Administracion", "Cuadrilla"],
          },
        ];
      }
      if (this.$store.getters.usuario.idRol == 2) {
        console.log("Entreo en el idRol 2");
        this.links = [
          {
            to: "/Tareas",
            icon: "mdi-pen-plus",
            text: "Tareas",
            rol: ["Administracion", "Cuadrilla"],
          },
          {
            to: "/ot",
            icon: "mdi-chart-areaspline-variant",
            text: "Almacen",
            rol: ["Administracion", "Cuadrilla"],
          },
          {
            to: "/Reportes",
            icon: "mdi-chart-areaspline-variant",
            text: "Reportes",
            rol: ["Administracion", "Cuadrilla"],
          },
        ];
      }
      if (this.$store.getters.usuario.idRol == 4) {
        console.log("Entreo en el idRol 4");
        this.links = [
          {
            to: "/Tareas",
            icon: "mdi-pen-plus",
            text: "Tareas",
            rol: ["Administracion", "Cuadrilla"],
          },
        ];
      }

      if (this.$store.getters.usuario.idRol == 3) {
        console.log("Entreo en el idRol 3");
        this.links = [
          {
            to: "/Cuadrillas",
            icon: "mdi-account-group",
            text: "Cuadrillas",
            rol: ["Administracion", "Cuadrilla"],
          },
          {
            to: "/Tareas",
            icon: "mdi-pen-plus",
            text: "Tareas",
            rol: ["Administracion", "Cuadrilla"],
          },
          // {
          //   to: "/ListadoTareasAsignadas",
          //   icon: "mdi-playlist-check",
          //   text: "Listado de Tareas Asignadas",
          //   rol: ["Administracion", "Cuadrilla"],
          // },
          {
            to: "/Almacen",
            icon: "mdi-store",
            text: "Almacen",
            rol: ["Administracion", "Cuadrilla"],
            subLinks: [
              {
                text: "Listado de Materiales",
                to: "/Materiales",
                icon: "mdi-tools",
              },
              {
                text: "Cajones",
                to: "/Cajones",
                icon: "mdi-toolbox",
              },
            ],
          },
          {
            to: "/Reportes",
            icon: "mdi-chart-areaspline-variant",
            text: "Reportes",
            rol: ["Administracion", "Cuadrilla"],
          },
          // {
          //   icon: "mdi-account-tie",
          //   text: "Usuarios",
          //   rol: ["Administracion", "Cuadrilla"],
          //   subLinks: [
          //     {
          //       text: "Agregar Usuario",
          //       to: "/AgregarUsuario",
          //       icon: "mdi-account-plus",
          //     },
          //     {
          //       text: "Agregar Tarea",
          //       to: "/AgregarTareaUsuario",
          //       icon: "mdi-playlist-plus",
          //     },
          //     {
          //       text: "Asignar Rol",
          //       to: "/AsignarRolUsuario",
          //       icon: "mdi-shield-account",
          //     },
          //   ],
          // },
        ];
        console.log("El id de usuario es: ");
        console.log(this.$store.getters.usuario.user_id);
        this.url =
          // "https://localhost:5001/Usuarios/login";
          this.$store.getters.urlBase + "Usuarios/contratista";
        const data = {
          idUsuario: this.$store.getters.usuario.user_id,
        };

        await axios
          .post(this.url, data)
          .then((response) => (this.respuesta = response))
          .catch((error) => {
            if (error.response) {
              this.mensajeSnack = error.response.data;
            } else {
              this.mensajeSnack = "Error de Conexion";
            }
            this.colorSnack = "red";
            this.Showsnackbar = true;
          });

        this.loadingButton = false;
        console.log("Los datos del contratista son: ");
        console.log(this.respuesta);
        if (this.respuesta.status === 200) {
          this.$store.getters.idContratista =
            this.respuesta.data[0].idContratista;
          this.$store.getters.contratistaDescripcion =
            this.respuesta.data.descripcionContratista;
          console.log("Los datos del usuario contratista son: ");
          console.log(this.$store.getters.idContratista);
          //console.log(this.$store.getters.descripcionContratista);
          console.log("fecha expiracion");
        }
      }
      if (this.$store.getters.usuario.idRol == 5) {
        console.log("Entreo en el idRol 5");
        this.links = [
          {
            to: "/Cuadrillas",
            icon: "mdi-account-group",
            text: "Cuadrillas",
            rol: ["Administracion", "Cuadrilla"],
          },
          {
            to: "/Tareas",
            icon: "mdi-pen-plus",
            text: "Tareas",
            rol: ["Administracion", "Cuadrilla"],
          },
          {
            to: "/Almacen",
            icon: "mdi-store",
            text: "Almacen",
            rol: ["Administracion", "Cuadrilla"],
            subLinks: [
              {
                to: "/ot",
                icon: "mdi-chart-areaspline-variant",
                text: "OT",
              },
              {
                text: "Listado de Materiales",
                to: "/Materiales",
                icon: "mdi-tools",
              },
              {
                text: "Cajones",
                to: "/Cajones",
                icon: "mdi-toolbox",
              },
            ],
          },
          {
            to: "/Reportes",
            icon: "mdi-chart-areaspline-variant",
            text: "Reportes",
            rol: ["Administracion", "Cuadrilla"],
          },
          // {
          //   icon: "mdi-account-tie",
          //   text: "Usuarios",
          //   rol: ["Administracion", "Cuadrilla"],
          //   subLinks: [
          //     {
          //       text: "Agregar Usuario",
          //       to: "/AgregarUsuario",
          //       icon: "mdi-account-plus",
          //     },
          //     {
          //       text: "Agregar Tarea",
          //       to: "/AgregarTareaUsuario",
          //       icon: "mdi-playlist-plus",
          //     },
          //     {
          //       text: "Asignar Rol",
          //       to: "/AsignarRolUsuario",
          //       icon: "mdi-shield-account",
          //     },
          //   ],
          // },
        ];
        console.log("El id de usuario es: ");
        console.log(this.$store.getters.usuario.user_id);
        this.url =
          // "https://localhost:5001/Usuarios/login";
          this.$store.getters.urlBase + "Usuarios/contratista";
        const data = {
          idUsuario: this.$store.getters.usuario.user_id,
        };

        await axios
          .post(this.url, data)
          .then((response) => (this.respuesta = response))
          .catch((error) => {
            if (error.response) {
              this.mensajeSnack = error.response.data;
            } else {
              this.mensajeSnack = "Error de Conexion";
            }
            this.colorSnack = "red";
            this.Showsnackbar = true;
          });

        this.loadingButton = false;
        console.log("Los datos del contratista son: ");
        console.log(this.respuesta);
        if (this.respuesta.status === 200) {
          this.$store.getters.idContratista =
            this.respuesta.data[0].idContratista;
          this.$store.getters.contratistaDescripcion =
            this.respuesta.data.descripcionContratista;
          console.log("Los datos del usuario contratista son: ");
          console.log(this.$store.getters.idContratista);
          //console.log(this.$store.getters.descripcionContratista);
          console.log("fecha expiracion");
        }
      }
    },

    tipoUsuario(idRol) {
      if (idRol == 2) {
        return "Operador";
      }
      if (idRol == 3) {
        return "Contratista";
      }
    },
    cerrarSesion() {
      this.$store.dispatch("agregarEmailAction", {});
      this.$router.push("/");
    },
    Home() {
      this.$router.push("/Principal");
    },
  },
};
</script>
